import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChevronUp = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M15.707 11.707a1 1 0 0 1-1.414 0L8 6.414l-6.293 5.293a1 1 0 0 1-1.414-1.414l7-6a1 1 0 0 1 1.414 0l7 6a1 1 0 0 1 0 1.414"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronUp;
